import React, { useEffect, useState } from 'react'
import { useBnsFanKuiJianChaUpdateQuery } from '../../store/ReactWebSiteApi';
import { Descriptions, Space, Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
import FeedbackEdit from './FeedbackEdit';
import FeedbackReport from './FeedbackReport';
import FeedbackState from './FeedbackState';
function FeedbackDesc(props) {
    const [info,setInfo] = useState({
        ebn_team_num:'',
    })
    const {data,isSuccess} = useBnsFanKuiJianChaUpdateQuery({bfkjc_id:props.bfkjc_id},{skip:!props.bfkjc_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({
                    bfkjc_dept_id:data.Result.bfkjc_dept_id,        
                    bfkjc_dept_name:data.Result.bfkjc_dept_name,        
                    bfkjc_bg_name:data.Result.bfkjc_bg_name,        
                    bfkjc_meijie_name:data.Result.bfkjc_meijie_name,  
                    bfkjc_ctime:data.Result.bfkjc_ctime,                                       
                    bfkjc_cname:data.Result.bfkjc_cname,                                       
                    bfkjc_jihuariqi:data.Result.bfkjc_jihuariqi,                                                
                    bfkjc_name:data.Result.bfkjc_name,                                                
                    bfkjc_fuzhuren_name:data.Result.bfkjc_fuzhuren_name,                                                
                    bfkjc_fankui_ctime:data.Result.bfkjc_fankui_ctime,                                                
                    bfkjc_state:data.Result.bfkjc_state,                                                
                    bfkjc_fankui_content:data.Result.bfkjc_fankui_content,                                                
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'2',
            label:'媒介',
            children:info.bfkjc_meijie_name,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'5',
            label:'负责人',
            children: info.bfkjc_fuzhuren_name,
            contentStyle:{fontSize:"18px"},
        }, 
        {
            key:'3',
            label:'计划日期',
            children:info.bfkjc_jihuariqi,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'4',
            label:'检查内容',
            children:info.bfkjc_name,
            contentStyle:{fontSize:"18px"},
            span:2
        },
        {
            key:'4',
            label:'状态',
            children: info.bfkjc_state==='1'?<>已实现</>:<>待实现</>,
            contentStyle:{fontSize:"18px"},
            span:2
        },
        {
            key:'bfkjc_fankui_ctime',
            label:'检查日期',
            children:info.bfkjc_fankui_ctime,
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'bfkjc_fankui_ctime',
            label:'检查说明',
            children:info.bfkjc_fankui_content,
            contentStyle:{fontSize:"18px"},
            span:3
        },
       
        {
            key:'7',
            label:'部门',
            children:<>{info.bfkjc_dept_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'8',
            label:'新增时间',
            children:info.bfkjc_cname+info.bfkjc_ctime,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'9',
            label:'操作',
            children:   <Space>
                             <FeedbackEdit
                                bfkjc_id={props.bfkjc_id}
                            />
                            <FeedbackReport
                                bfkjc_id={props.bfkjc_id}
                            />
                            <FeedbackState
                                bfkjc_id={props.bfkjc_id}
                                bfkjc_state={info.bfkjc_state}
                            /> 
                        </Space>,
        },
    ]
    return (
        <>
            {info.bfkjc_ctime ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                   <DocTitle
                                        name='反馈检查任务说明书'
                                        num={props.bfkjc_id}                        
                                    />                                    
                                    <Descriptions
                                        items={items}
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default FeedbackDesc